import React from 'react';
import * as S from './WaitingFor.styles';

const WaitingFor = () => {

    const scrollTop = () => {
        window.scrollTo({top:0, behaviour: 'auto'});
    }

    return(
        <S.WaitingForMainWrap>
            <S.WaitingForInnerWrap>
                <S.WaitingForHeadText>Don’t wait, start growing your business with myPartner today!</S.WaitingForHeadText>
                <S.WaitingForButton onClick={scrollTop}>Sign Up Now</S.WaitingForButton>
            </S.WaitingForInnerWrap>
        </S.WaitingForMainWrap>
    )
}

export default WaitingFor;